<template>
  <div class="section">
    <div class="box">
      <div class="field">
        <label class="label">Select Service</label>
        <div class="control">
          <div class="select">
            <select v-model="service">
              <option value="">Select Service</option>
              <option v-for="(service_row, index) in service_list" :key="index" :value="service_row.id" v-text="service_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" @click="getSeatData()">Show</button>
        </div>
      </div>
      <div class="tile is-ancestor" v-for="(new_people_chair_row, index) in new_people_chair_list" :key="index">
        <div class="tile is-12">
          <div class="tile is-parent" v-for="(new_people_chair_row_seat, index_seat) in new_people_chair_row" :key="index_seat" @click="selectSeat(new_people_chair_row_seat, index, index_seat)">
            <article :class="{'tile': true, 'is-child': true, 'notification': true, 'has-text-centered': true, 'no-padding': new_people_chair_row_seat.is_selected === 1, 'is-link': new_people_chair_row_seat.is_selected === 0, 'is-warning': new_people_chair_row_seat.is_selected === 1}">
              <span v-text="new_people_chair_row_seat.title"></span>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      service: '',
      service_list: [],
      new_people_chair_list: []
    }
  },
  created () {
    this.getService()
  },
  methods: {
    getService () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGet('new_people/get_services').then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.service_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    },
    getSeatData () {
      var self = this
      self.flyPostSession('task/get_seat_service_data', {
        service: this.service
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.new_people_chair_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/floorarea/SeatInfo.vue